import React, { useState, useEffect, Component } from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import { cloneDeep } from "lodash";
import DatePicker from "react-datepicker";
import CloseModal from "../../../Components/CloseModal";
import {
  saveorupdatespokemaster,
  getdetailsbypincode,
} from "../../../Utils/Services/spokeMaster";
import { searchBranchesWithFilter } from "../../../Utils/Services/BranchMaster";

toast.configure();

const initForm = {
  spokeName: "",
  partnerId: null,
  pincode: "",
  tehsil: "",
  state: "",
  dateOfEstablishment: "",
  district: "",
  businessType: "",
  status: "",
  branchName: "",
  branchId: null,
  latitude: "",
  longitude: "",
  errors: {
    spokeName: null,
    partnerId: null,
    pincode: null,
    dateOfEstablishment: null,
    businessType: null,
    tehsil: null,
    district: null,
    state: null,
    // NOTE: keep latitude/longitude ahead of branchId. The diableSave loop in
    // render() only reflects the LAST key of this object, so appending here
    // would change long-standing behaviour of that loop.
    latitude: null,
    longitude: null,
    status: null,
    branchName: null,
    branchId: null,
  },
};
const BusinessTypeOptions = [
  { label: "Lending", value: "LENDING" },
  { label: "FARM", value: "FARM" },
];

const LATITUDE_MIN = 6;
const LATITUDE_MAX = 38;
const LONGITUDE_MIN = 68;
const LONGITUDE_MAX = 98;


const COMPLETE_NUMBER_REGEX = /^-?\d+(\.\d+)?$/;

const isWithinRange = (value, min, max) => {
  if (value === "" || value === null || value === undefined) return false;

  const str = String(value).trim();
  if (!COMPLETE_NUMBER_REGEX.test(str)) return false;
  const num = Number(str);
  return !Number.isNaN(num) && num >= min && num <= max;
};

const isValidLatitude = (value) =>
  isWithinRange(value, LATITUDE_MIN, LATITUDE_MAX);
const isValidLongitude = (value) =>
  isWithinRange(value, LONGITUDE_MIN, LONGITUDE_MAX);
const userInfo = JSON.parse(localStorage.getItem("userInfo"));
const isITADMIN = userInfo?.role === "ITADMIN";
export class AddEditSpoke extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tehsilsdropdownvalue: [],
      pincodedetails: [],
      showModal: false,
      Loading: false,
      showInner: false,
      form: cloneDeep(initForm),
      stateDropdownValues: [],
      districtDropdownValues: [],
      branchDropdownValues: [],
      selectedDate: "",
    };
  }

  componentDidMount = () => {
    let { form, selectedDate } = this.state;
    this.setState({ showModal: true });
    if (this.props.editData && this.props.action == "edit") {
      let {
        form,
        selectedDate,
        tehsilsdropdownvalue,
        districtDropdownValues,
        stateDropdownValues,
        branchDropdownValues,
      } = this.state;
      selectedDate = this.props.editData.dateOfEstablishment;
      let obj = { ...form, ...this.props.editData };
      obj.businessType = this.props.editData.businessType || "";

      obj.latitude =
        this.props.editData.latitude === null ||
        this.props.editData.latitude === undefined
          ? ""
          : String(this.props.editData.latitude);
      obj.longitude =
        this.props.editData.longitude === null ||
        this.props.editData.longitude === undefined
          ? ""
          : String(this.props.editData.longitude);
      tehsilsdropdownvalue.push({ value: obj.tehsil, label: obj.tehsil });
      districtDropdownValues.push({ value: obj.district, label: obj.district });
      stateDropdownValues.push({ value: obj.state, label: obj.state });
      
      // Add branch name to dropdown if it exists
      if (obj.branchName) {
        branchDropdownValues.push({ 
          value: obj.branchId || obj.branchName, 
          label: obj.branchName,
          branchId: obj.branchId,
          branchName: obj.branchName
        });
      }
      
      this.setState({
        form: obj,
        selectedDate,
        tehsilsdropdownvalue,
        districtDropdownValues,
        stateDropdownValues,
        branchDropdownValues,
      });
    }
  };

  alldetailsbypincode = (pincode) => {
    let {
      form,
      stateDropdownValues,
      districtDropdownValues,
      tehsilsdropdownvalue,
    } = this.state;
    getdetailsbypincode(pincode)
      .then((response) => {
        console.log("pincodeaddress", response);
        if (response.error) {
          return;
        }
        if (response.data.error) {
          return;
        } else {
          const stateSet = new Set();
          const districtSet = new Set();
          const tehsilSet = new Set();
          const tehsils = [];
          const states = [];
          const districts = [];

          for (var i = 0; i < response.data.length; i++) {
            stateSet.add(response.data[i].state);
          }
          for (var i of stateSet) {
            states.push({ value: i, label: i });
          }
          for (var j = 0; j < response.data.length; j++) {
            districtSet.add(response.data[j].district);
          }
          for (var j of districtSet) {
            districts.push({ value: j, label: j });
          }
          for (var k = 0; k < response.data.length; k++) {
            tehsilSet.add(response.data[k].tehsil);
          }
          for (var k of tehsilSet) {
            tehsils.push({ value: k, label: k });
          }
          form.tehsil = tehsils && tehsils[0] && tehsils[0].value;
          form.district = districts && districts[0] && districts[0].value;
          form.state = states && states[0] && states[0].value;
          
          const stateId = response.data[0]?.stateId;
          if (stateId) {
            this.searchBranchesByState(stateId);
          }
          
          this.setState({
            form,
            stateDropdownValues: states,
            districtDropdownValues: districts,
            tehsilsdropdownvalue: tehsils,
          });
        }
      })
      .catch((err) => {
        console.log("error is: ", err);
      });
  };

  searchBranchesByState = (stateId) => {
    const filterParams = {
      stateId: stateId,
      regionId: null,
      branchName: null
    };
    
    searchBranchesWithFilter(filterParams)
      .then((response) => {
        console.log("branch search response", response);
        if (response.error) {
          return;
        }
        if (response.data && response.data.result) {
          const branches = response.data.result.map(branch => ({
            value: branch.id,
            label: branch.branchName,
            branchId: branch.id,
            branchName: branch.branchName
          }));
          this.setState({
            branchDropdownValues: branches
          });
        }
      })
      .catch((err) => {
        console.log("error searching branches: ", err);
      });
  };

  handleModalClose = () => {
    this.setState({ showInner: !this.state.showInner });
  };

  innerModalClose = (modclose) => {
    if (!modclose) {
      this.handleModalClose();
    }
    this.setState({ showModal: false });
    if (this.props.action == "edit") {
      this.props.handleEditSpokeMaster();
    } else {
      this.props.handleAddSpoke();
    }
  };
  handleSubmit = (performActive) => {
    let { form } = this.state;

    if (this.props.action === "edit" && performActive) {
      form.status = form.status === false ? true : false;
    }

    if (Array.isArray(form.businessType)) {
      form.businessType = form.businessType.join(",");
    }

    form.partnerId = form.partnerId === "" ? null : form.partnerId;

    form.latitude =
      form.latitude === null || form.latitude === undefined
        ? ""
        : String(form.latitude).trim();
    form.longitude =
      form.longitude === null || form.longitude === undefined
        ? ""
        : String(form.longitude).trim();

    let obj = form;
    this.setState({ Loading: true });

    saveorupdatespokemaster(obj).then((response) => {
      this.setState({ Loading: false });
      if (response.error) {
        // Error toast already shown by HTTP interceptor
        return;
      } else {
        if (this.props.editData && this.props.action == "edit") {
          toast.success("Data Updated Successfully", {
            type: toast.TYPE.SUCCESS,
            autoClose: 4000,
          });
          this.props.handleEditSpokeMaster();
          window.location.reload();
        } else {
          toast.success("Data Saved Successfully", {
            type: toast.TYPE.SUCCESS,
            autoClose: 4000,
          });
          this.props.handleAddSpoke({});
          window.location.reload();
        }
      }
    });
  };

  handleInputChange = (e, name) => {
    e.preventDefault();
    let { form } = this.state;
    form[name] = e.target.value;
    this.setState({ form });
  };

  handlepartnerId = (e, name) => {
    let { form } = this.state;
    form[name] = e.target.value;
    this.setState({ form });
  };
  handleValidatepartnerId = (e, name) => {
    e.preventDefault();
    let { form, errors } = this.state;
    let value = form[name];
    if (
      (name == "partnerId" && value === null) ||
      e.target.value.length === 0
    ) {
      return this.setState({
        form: { ...form, errors: { ...form.errors, partnerId: null } },
      });
    }

    if (
      value === "" ||
      value === null ||
      value === undefined ||
      (name == "partnerId" && value.length < 4 && value.length !== 6)
    ) {
      form.errors[name] = true;
      this.setState({ form });
    } else {
      form.errors[name] = null;
      this.setState({ form });
    }
  };

  restrictAlphabets = (e) => {
    const regx = "^[0-9]*$";
    if (e.key.match(regx)) {
      return true;
    } else {
      e.preventDefault();
    }
  };

  handleBranchTehsilDistrict = (e, name) => {
    let regx = /^[a-zA-Z][a-zA-Z0-9()\-\. ]*$/g;
    if (e.target.value.match(regx) || e.target.value === "") {
      let { form } = this.state;
      form[name] = e.target.value;
      this.setState({ form });
    }
  };

  handleValidateBranchtehsildiststate = (e, name) => {
    e.preventDefault();
    let { form, errors } = this.state;
    let value = form[name];
    
    // Skip validation for state field as it's now optional
    if (name === "state") {
      form.errors[name] = null;
      this.setState({ form });
      return;
    }
    
    if (
      value === "" ||
      value === null ||
      value === undefined ||
      (name == "spokeName" && value && e.target.value.trim().length < 3)
    ) {
      form.errors[name] = true;
      this.setState({ form });
    } else {
      form.errors[name] = null;
      this.setState({ form });
    }
  };

  handleStateSelectChange = (e, name) => {
    let { form } = this.state;
    let { value } = e;
    form[name] = value;
    this.setState({ form });
  };

  handleBranchSelectChange = (e, name) => {
    let { form } = this.state;
    let { value, branchId, branchName } = e;
    form[name] = value;
    form.branchId = branchId;
    form.branchName = branchName;
    
    // Clear validation error when branch is selected
    if (form.errors.branchName) {
      form.errors.branchName = null;
    }
    
    this.setState({ form });
  };

  handleValidateBranch = (e, name) => {
    e.preventDefault();
    let { form, errors } = this.state;
    let value = form[name];
    if (
      value === "" ||
      value === null ||
      value === undefined
    ) {
      form.errors[name] = true;
      this.setState({ form });
    } else {
      form.errors[name] = null;
      this.setState({ form });
    }
  };

  handlePincode = (e, name) => {
    e.preventDefault();
    let { form } = this.state;
    const pincodeValue = e.target.value;
    
    form[name] = pincodeValue;
    this.setState({ form });
    
    // If pincode is cleared or made blank, clear all location fields including branch
    if (name === "pincode" && (pincodeValue === "" || pincodeValue.length <= 5)) {
      this.clearAll();
    } else if (name === "pincode" && pincodeValue.length > 5) {
      // Clear location fields first, then fetch new data
      this.clearLocationFields();
      this.alldetailsbypincode(pincodeValue);
    }
  };
  
  clearLocationFields = () => {
    let {
      form,
      stateDropdownValues,
      tehsilsdropdownvalue,
      districtDropdownValues,
    } = this.state;
    form.tehsil = "";
    form.district = "";
    form.state = "";
    stateDropdownValues.splice(0, stateDropdownValues.length);
    districtDropdownValues.splice(0, districtDropdownValues.length);
    tehsilsdropdownvalue.splice(0, tehsilsdropdownvalue.length);

    this.setState({
      form,
      stateDropdownValues,
      tehsilsdropdownvalue,
      districtDropdownValues,
    });
  };
  
  clearAll = () => {
    let {
      form,
      stateDropdownValues,
      tehsilsdropdownvalue,
      districtDropdownValues,
      branchDropdownValues,
    } = this.state;
    form.tehsil = "";
    form.district = "";
    form.state = "";
    form.branchName = "";
    form.branchId = null;
    stateDropdownValues.splice(0, stateDropdownValues.length);
    districtDropdownValues.splice(0, districtDropdownValues.length);
    tehsilsdropdownvalue.splice(0, tehsilsdropdownvalue.length);
    branchDropdownValues.splice(0, branchDropdownValues.length);

    this.setState({
      form,
      stateDropdownValues,
      tehsilsdropdownvalue,
      districtDropdownValues,
      branchDropdownValues,
    });
  };

  handlevalidationDateOfEstablishment = (e, name) => {
    e.preventDefault();
    let { form, errors } = this.state;
    let value = form[name];
    if (value === "" || value === null || value === undefined) {
      form.errors[name] = true;
      this.setState({ errors });
    } else {
      form.errors[name] = null;
      this.setState({ errors });
    }
  };
  handleValidatePincode = (e, name) => {
    e.preventDefault();
    let { form, errors } = this.state;
    let value = form[name];
    if (
      value === "" ||
      value === null ||
      value === undefined ||
      (name == "pincode" && value && value.length !== 6)
    ) {
      form.errors[name] = true;
      this.setState({ form });
    } else {
      form.errors[name] = null;
      this.setState({ form });
    }
  };

  handleDateOfEstablishment = (date, e) => {
    let { form, selectedDate } = this.state;
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var dt = date.getDate();

    if (dt < 10) {
      dt = "0" + dt;
    }
    if (month < 10) {
      month = "0" + month;
    }

    form.dateOfEstablishment = dt + "-" + month + "-" + year;
    selectedDate = date;
    this.setState({ form, selectedDate });
  };

  handleMultiSelectChange = (selectedOptions, fieldName) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((opt) => opt.value).join(",")
      : "";

    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        [fieldName]: selectedValues,
      },
      errors: {
        ...prevState.form.errors,
        [fieldName]: "",
      },
    }));
  };

  handleLatLongChange = (e, name) => {
    let { form } = this.state;
    const value = e.target.value;
    // Typing guard: permits "", "2", "23.", "23.45", "-", "-1" so a decimal can
    // actually be typed; blocks letters, spaces, "+" and "1.2.3".
    // restrictAlphabets() is NOT reusable here - it blocks the decimal point.
    if (value === "" || /^-?\d*\.?\d*$/.test(value)) {
      form[name] = value;
      if (
        name === "latitude" ? isValidLatitude(value) : isValidLongitude(value)
      ) {
        form.errors[name] = null;
      }
      this.setState({ form });
    }
  };

  handleValidateLatLong = (e, name) => {
    e.preventDefault();
    let { form } = this.state;
    const value = form[name];
    const isLat = name === "latitude";
    if (value === "" || value === null || value === undefined) {
      form.errors[name] = true;
    } else if (isLat ? isValidLatitude(value) : isValidLongitude(value)) {
      form.errors[name] = null;
    } else {
      form.errors[name] = isLat
        ? `Latitude must be between ${LATITUDE_MIN} and ${LATITUDE_MAX}`
        : `Longitude must be between ${LONGITUDE_MIN} and ${LONGITUDE_MAX}`;
    }
    this.setState({ form });
  };

  render() {
    let {
      form,
      showModal,
      showInner,
      Loading,
      tehsilsdropdownvalue,
      stateDropdownValues,
      districtDropdownValues,
      branchDropdownValues,
      selectedDate,
    } = this.state;
    let { errors } = form;
    let diableSave = false;

    // Check if all mandatory fields are filled
    let isRequiredFeildFilled = false;
    
    // Check mandatory fields explicitly
    const mandatoryFields = {
      spokeName: form.spokeName,
      pincode: form.pincode,
      dateOfEstablishment: form.dateOfEstablishment,
      tehsil: form.tehsil,
      district: form.district,
      branchName: form.branchName,  
      branchId: form.branchId,
      businessType: form.businessType
    };
    
    // Check each mandatory field
    if (
      !mandatoryFields.spokeName ||
      mandatoryFields.spokeName === "" ||
      !mandatoryFields.pincode ||
      mandatoryFields.pincode === "" ||
      !mandatoryFields.dateOfEstablishment ||
      mandatoryFields.dateOfEstablishment === "" ||
      !mandatoryFields.tehsil ||
      mandatoryFields.tehsil === "" ||
      !mandatoryFields.district ||
      mandatoryFields.district === "" ||
      !mandatoryFields.branchName ||
      mandatoryFields.branchName === "" ||
      !mandatoryFields.branchId ||
      mandatoryFields.branchId === null ||
      !mandatoryFields.businessType ||
      mandatoryFields.businessType === "" ||
      (Array.isArray(mandatoryFields.businessType) && mandatoryFields.businessType.length === 0)
    ) {
      isRequiredFeildFilled = true;
    }

    const isLatLongInvalid =
      !isValidLatitude(form.latitude) || !isValidLongitude(form.longitude);

    Object.keys(errors).map((error) => {
      if (errors[error] == true || errors[error] != null) {
        diableSave = true;
      } else {
        diableSave = false;
      }
    });
    return (
      <React.Fragment>
        <Modal
          className="product-norm-container"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showModal}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>
              {this.props.action == "edit"
                ? "Edit Spoke"
                : "Spoke Creation Form"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            {Loading ? (
              <h4 className="text-center">LOADING...</h4>
            ) : (
              <>
                <div className="row ">
                  <div className="mb-4 col-md-4">
                    <label>
                      <i className="text-danger">*</i>Spoke Name
                    </label>
                    {console.log("spoke details are: ", form)}
                    <input
                      disabled={this.props.action === "edit"}
                      type="text"
                      pattern="\d*"
                      maxLength="100"
                      name="spokeName"
                      value={form && form.spokeName}
                      onChange={(e) => {
                        this.handleBranchTehsilDistrict(e, "spokeName");
                      }}
                      onBlur={(e) =>
                        this.handleValidateBranchtehsildiststate(e, "spokeName")
                      }
                      placeholder="Enter Spoke"
                      className={`form-input ${
                        errors.spokeName ? "error-input-border" : ""
                      } `}
                    />
                    {errors.spokeName && (
                      <span className="errorMsg">
                        {errors.spokeName === true
                          ? "Enter Valid Spoke Name"
                          : errors.spokeName}
                      </span>
                    )}
                  </div>
                  <div className="mb-4 col-md-4 ">
                    <label>
                      <i className="text-danger">*</i> Pincode
                    </label>
                    <input
                      type="text"
                      pattern="\d*"
                      name="pincode"
                      maxLength="6"
                      value={form && form.pincode}
                      onKeyPress={this.restrictAlphabets}
                      onChange={(e) => {
                        this.handlePincode(e, "pincode");
                      }}
                      disabled={!isITADMIN}
                      onBlur={(e) => this.handleValidatePincode(e, "pincode")}
                      placeholder="Enter Pincode"
                      className={`form-input ${
                        errors.pincode ? "error-input-border" : ""
                      } `}
                    />
                    {errors.pincode && !form.pincode && (
                      <span className="errorMsg">
                        {errors.pincode === true
                          ? "Please enter valid pincode"
                          : errors.pincode}
                      </span>
                    )}
                  </div>
                  <div className="mb-4 col-md-4">
                    <label>
                      {" "}
                      <i className="text-danger">*</i>
                      Date of Establishment{" "}
                    </label>
                    <div class="inner-addon right-addon">
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        placeholderText="DD-MM-YYYY"
                        value={form.dateOfEstablishment}
                        onChange={this.handleDateOfEstablishment}
                        onBlur={(e) =>
                          this.handlevalidationDateOfEstablishment(
                            e,
                            "dateOfEstablishment"
                          )
                        }
                        className={`form-input ${
                          errors.dateOfEstablishment ? "error-input-border" : ""
                        } `}
                        disabled={!isITADMIN}
                        maxDate={new Date()}
                      />
                    </div>
                    {errors.dateOfEstablishment && (
                      <span className="errorMsg">
                        Please Select Date Of Establishment
                      </span>
                    )}
                  </div>
                </div>
                <div className="row ">
                  <div className="mb-4 col-md-4 ">
                    <label>
                      Tehsil<i className="text-danger">*</i>
                    </label>
                    <Select
                      value={
                        tehsilsdropdownvalue.filter(
                          (item) => item.value == form.tehsil
                        ) || ""
                      }
                      onChange={(e) => {
                        this.handleStateSelectChange(e, "tehsil");
                      }}
                      onBlur={(e) =>
                        this.handleValidateBranchtehsildiststate(e, "tehsil")
                      }
                      name="tehsil"
                      options={tehsilsdropdownvalue}
                      placeholder="Select Tehsil"
                      valueKey="label"
                      labelKey="value"
                      getOptionLabel={(option) => option["label"]}
                      getOptionValue={(option) => option["value"]}
                      className={`${errors.state ? "error-input-border" : ""} `}
                      isDisabled={!isITADMIN}
                    />
                    {errors.tehsil && !form.tehsil && (
                      <span className="errorMsg">
                        {errors.tehsil === true
                          ? "Please enter tehsil"
                          : errors.tehsil}
                      </span>
                    )}
                  </div>

                  <div className="mb-4 col-md-4">
                    <label>
                      <i className="text-danger">*</i>District
                    </label>
                    <Select
                      value={
                        districtDropdownValues.filter(
                          ({ value }) => value == form.district
                        ) || ""
                      }
                      onChange={(e) => {
                        this.handleStateSelectChange(e, "district");
                      }}
                      onBlur={(e) =>
                        this.handleValidateBranchtehsildiststate(e, "district")
                      }
                      name="district"
                      options={districtDropdownValues}
                      placeholder="Select district"
                      valueKey="label"
                      labelKey="value"
                      getOptionLabel={(option) => option["label"]}
                      getOptionValue={(option) => option["value"]}
                      className={`${errors.state ? "error-input-border" : ""} `}
                      isDisabled={!isITADMIN}
                    />
                    {errors.district && !form.district && (
                      <span className="errorMsg">
                        {errors.district === true
                          ? "Please select district"
                          : errors.district}
                      </span>
                    )}
                  </div>

                  <div className="mb-4 col-md-4">
                    <label>
                      State
                    </label>
                    <Select
                      value={
                        stateDropdownValues.filter(
                          ({ value }) => value == form.state
                        ) || ""
                      }
                      onChange={(e) => {
                        this.handleStateSelectChange(e, "state");
                      }}
                      onBlur={(e) =>
                        this.handleValidateBranchtehsildiststate(e, "state")
                      }
                      name="state"
                      options={stateDropdownValues}
                      placeholder="Select State"
                      valueKey="label"
                      labelKey="value"
                      getOptionLabel={(option) => option["label"]}
                      getOptionValue={(option) => option["value"]}
                      className={`${errors.state ? "error-input-border" : ""} `}
                      isDisabled={!isITADMIN}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="mb-4 col-md-4">
                    <label>
                      <i className="text-danger">*</i> Branch Name
                    </label>
                    <Select
                      value={
                        branchDropdownValues.filter(
                          ({ value }) => value == form.branchId
                        ) || ""
                      }
                      onChange={(e) => {
                        this.handleBranchSelectChange(e, "branchId");
                      }}
                      onBlur={(e) =>
                        this.handleValidateBranch(e, "branchName")
                      }
                      name="branchId"
                      options={branchDropdownValues}
                      placeholder="Select Branch Name"
                      valueKey="label"
                      labelKey="value"
                      getOptionLabel={(option) => option["label"]}
                      getOptionValue={(option) => option["value"]}
                      className={`${errors.branchName ? "error-input-border" : ""} `}
                      isDisabled={!isITADMIN}
                    />
                    {errors.branchName && !form.branchName && (
                      <span className="errorMsg">
                        {errors.branchName === true
                          ? "Please select branch name"
                          : errors.branchName}
                      </span>
                    )}
                  </div>
                  <div className="mb-4 col-md-4">
                    <label>
                      <i className="text-danger">*</i> Business Type
                    </label>
                    <Select
                      isMulti
                      name="businessType"
                      placeholder="Select businessType(s)"
                      options={BusinessTypeOptions}
                      value={BusinessTypeOptions.filter((opt) =>
                        Array.isArray(form.businessType)
                          ? form.businessType.includes(opt.value)
                          : form.businessType?.split(",")?.includes(opt.value)
                      )}
                      onChange={(selectedOptions) =>
                        this.handleMultiSelectChange(
                          selectedOptions,
                          "businessType"
                        )
                      }
                      isDisabled={!isITADMIN}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      className={`${
                        errors.businessType ? "error-input-border" : ""
                      }`}
                    />
                    {errors.businessType && (
                      <span className="errorMsg">
                        Please select a business Type
                      </span>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="mb-4 col-md-4">
                    <label htmlFor="latitude">
                      <i className="text-danger">*</i> Latitude
                    </label>
                    <input
                      type="text"
                      inputMode="decimal"
                      maxLength="12"
                      id="latitude"
                      name="latitude"
                      value={form.latitude || ""}
                      onChange={(e) => {
                        this.handleLatLongChange(e, "latitude");
                      }}
                      onBlur={(e) => this.handleValidateLatLong(e, "latitude")}
                      disabled={!isITADMIN}
                      placeholder={`Enter Latitude`}
                      className={`form-input ${
                        errors.latitude ? "error-input-border" : ""
                      } `}
                    />
                    {errors.latitude && (
                      <span className="errorMsg">
                        {errors.latitude === true
                          ? "Please enter latitude"
                          : errors.latitude}
                      </span>
                    )}
                  </div>
                  <div className="mb-4 col-md-4">
                    <label htmlFor="longitude">
                      <i className="text-danger">*</i> Longitude
                    </label>
                    <input
                      type="text"
                      inputMode="decimal"
                      maxLength="12"
                      id="longitude"
                      name="longitude"
                      value={form.longitude || ""}
                      onChange={(e) => {
                        this.handleLatLongChange(e, "longitude");
                      }}
                      onBlur={(e) => this.handleValidateLatLong(e, "longitude")}
                      disabled={!isITADMIN}
                      placeholder={`Enter Longitude`}
                      className={`form-input ${
                        errors.longitude ? "error-input-border" : ""
                      } `}
                    />
                    {errors.longitude && (
                      <span className="errorMsg">
                        {errors.longitude === true
                          ? "Please enter longitude"
                          : errors.longitude}
                      </span>
                    )}
                  </div>
                </div>
                {this.props.action === "edit" && (
                  <div className="row">
                    <div className="mb-4 col-md-4">
                      <label>Partner Id</label>
                      <input
                        type="text"
                        pattern="\d*"
                        maxLength="6"
                        disabled={true}
                        name="partnerId"
                        value={form && form.partnerId}
                        onKeyPress={this.restrictAlphabets}
                        onChange={(e) => {
                          this.handlepartnerId(e, "partnerId");
                        }}
                        onBlur={(e) =>
                          this.handleValidatepartnerId(e, "partnerId")
                        }
                        placeholder="Enter Partner Id"
                        className={`form-input ${
                          errors.partnerId ? "error-input-border" : ""
                        } `}
                      />
                      {errors.partnerId && (
                        <span className="errorMsg">
                          {errors.partnerId == true
                            ? "Please enter valid Partner Id"
                            : errors.partnerId}
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            {isITADMIN && (
              <>
                {this.props.action === "edit" ? (
                  <Button
                    className="success"
                    onClick={() => this.handleSubmit(true)}
                    disabled={
                      diableSave ||
                      isRequiredFeildFilled ||
                      isLatLongInvalid ||
                      Loading
                    }
                  >
                    {form.status === true ? "Inactive" : "Active"}
                  </Button>
                ) : null}
              </>
            )}
            <Button className="btn-danger" onClick={this.handleModalClose}>
              Cancel
            </Button>
            {isITADMIN && (
              <Button
                className="btn-success"
                disabled={
                  diableSave ||
                  isRequiredFeildFilled ||
                  isLatLongInvalid ||
                  Loading
                }
                onClick={() => this.handleSubmit(false)}
              >
                {this.props.action == "edit" ? "Update" : "Save"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>
        <CloseModal
          show={showInner}
          button2={this.handleModalClose}
          button1={this.innerModalClose}
          title="Do you want to close ?"
        />
      </React.Fragment>
    );
  }
}

AddEditSpoke.propTypes = {
  action: PropTypes.string,
  editData: PropTypes.shape({
    spokeName: PropTypes.string,
    partnerId: PropTypes.any,
    pincode: PropTypes.any,
    tehsil: PropTypes.string,
    district: PropTypes.string,
    state: PropTypes.string,
    dateOfEstablishment: PropTypes.any,
    businessType: PropTypes.any,
    branchName: PropTypes.string,
    branchId: PropTypes.any,
    // latitude/longitude stay `any`: the API returns them as either a JSON
    // number or a string, which is why componentDidMount normalizes them.
    latitude: PropTypes.any,
    longitude: PropTypes.any,
    status: PropTypes.bool,
  }),
  handleAddSpoke: PropTypes.func,
  handleEditSpokeMaster: PropTypes.func,
};

export default AddEditSpoke;
